import { createSlice } from "@reduxjs/toolkit";

import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const navigateTo = "/locations";

const initialState = {
  locations: [],
  locationsObject: [],
  error: null,
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

// Reducer
const slice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },

    // GET USERS STYLE 1
    getSuccess(state, action) {
      const data = action.payload.data;
      state.locations = utils.sortAlphatically(data, "name");
      state.locationsObject = utils.getUniqueObject(data, "id");
      const total = action.payload.totalItems;
      let pages = Math.floor(total / state.limit);
      const remainder = total % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },
    addSuccess(state, action) {
      state.loading = false;
    },
    editSuccess(state, action) {
      state.loading = false;
    },
    deleteSuccess(state, action) {
      state.loading = false;
      state.locations = state.locations.filter(
        (item) => item.id !== action.payload.id
      );
    },
    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getLocations() {
  return async () => {
    try {
      const result = await axios.get(`/locations?size=1000`);
      console.log("RES [getLocations]:", result.data);
      dispatch(slice.actions.getSuccess(result.data));
    } catch (error) {
      console.log("ERR [getLocations]:", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addLocation(data, navigate) {
  return async () => {
    try {
      const result = await axios.post(`/locations`, data);
      console.log("RES [addLocation] ======> ", result.data.data);
      dispatch(slice.actions.addSuccess(result.data.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [addLocation] =======> ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editLocation(id, data, navigate) {
  return async () => {
    try {
      const result = await axios.put(`/locations/${id}`, data);
      console.log("RES [editLocation] =======> ", result?.data?.data);
      dispatch(slice.actions.editSuccess(result?.data?.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [editLocation] ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteLocation(id = "") {
  return async () => {
    try {
      const result = await axios.delete(`/locations/${id}`);
      console.log("RES [deleteLocation] =======> ", result);
      dispatch(slice.actions.deleteSuccess(result.data.data));
      dispatch(getLocations());
    } catch (error) {
      dispatch(getLocations());
      console.log("ERR [deleteLocation] =========> ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
